// src/web/routes/__root.tsx

import { ArrowLeftIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router'
import { AppErrorBoundary } from '@/components/ErrorBoundary'
import { Button } from '@/components/ui/button'
import { useThemeEffect } from '@/hooks/useThemeEffect'

interface RouterContext {
	queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
	component: RootComponent,
	notFoundComponent: NotFound,
})

function RootComponent() {
	useThemeEffect()

	return (
		<AppErrorBoundary>
			<div className="min-h-screen bg-background">
				<Outlet />
			</div>
		</AppErrorBoundary>
	)
}

function NotFound() {
	return (
		<div className="min-h-screen flex items-center justify-center bg-background px-4">
			<div className="max-w-md w-full text-center">
				<div className="mb-6 flex justify-center">
					<div className="relative">
						<div className="absolute inset-0 bg-primary/10 rounded-full blur-3xl opacity-50 animate-pulse" />
						<div className="relative w-24 h-24 rounded-full bg-primary/5 border border-primary/20 flex items-center justify-center">
							<ExclamationTriangleIcon className="w-12 h-12 text-primary" />
						</div>
					</div>
				</div>
				<h1 className="text-7xl font-bold text-foreground tracking-tight mb-2">404</h1>
				<p className="text-xl font-medium text-foreground mb-2">Page not found</p>
				<p className="text-muted-foreground mb-8">
					Sorry, we couldn't find the page you're looking for.
				</p>
				<Link to="/home">
					<Button variant="default" size="lg" className="gap-2">
						<ArrowLeftIcon className="w-4 h-4" />
						Go back home
					</Button>
				</Link>
			</div>
		</div>
	)
}
